import { render, staticRenderFns } from "./monresto.vue?vue&type=template&id=ebcea4fa&"
import script from "./monresto.vue?vue&type=script&lang=js&"
export * from "./monresto.vue?vue&type=script&lang=js&"
import style0 from "./monresto.vue?vue&type=style&index=0&id=ebcea4fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports